<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container>
            <v-data-table
              :headers="headers"
              :items="results"
              :pagination.sync="pagination"
              :total-items="totalResults"
              :loading="loading"
              class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.makerUsername }}</td>
              <td>{{ props.item.uploadedFileName }}</td>
              <td>{{ props.item.processingResultFileName }}</td>
              <td>{{ props.item.createdAt }}</td>
              <td>{{ props.item.uploadedAt }}</td>
              <td class="justify-center layout px-0">
                <v-btn
                  primary
                  class="mr-2"
                  @click="downloadItem(props.item)"
                >
                  Download
                </v-btn>
              </td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewprocessingresults',
  data: function() {
    return {
      headers: [
        {
          text: 'Id',
          value: 'id'
        },
        { text: 'Maker Username', value: 'makerUsername' },
        { text: 'Upload File Name', value: 'uploadedFileName' },
        { text: 'Result File Name', value: 'processingResultFileName' },
        { text: 'Uploaded At', value: 'createdAt' },
        { text: 'Result Uploaded At', value: 'uploadedAt' }
      ],
      results: [],
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalResults: 0
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getFileUploadResults()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getFileUploadResults () {
      var url = config.serverURI + '/originator/processing/result'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.results = response.data
            this.totalResults = this.results.total
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.results
    },
    downloadItem (item) {
      var url = config.serverURI + '/file/download?fileName=' + item.processingResultFileName
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Access-Control-Allow-Origin': '*'
        },
        responseType: 'blob'
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', item.processingResultFileName)
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// originatorprocessingresults.vue?cc6c252a